import { AddressInterface } from "./Address";

export type UserInterface = {
  firstName: string;
  lastName: string;
  accessibility: string;
  otherAccessibility: string;
  dateOfBirth: string;
  email: string;
  age: number;
  roles: string[];
  canEditAllocations: number[];
  readOnlyAllocations: number[];
  canSendTicketsFromAllocation: number[];
  loginStatus?: string;
  isVirtual: boolean;
}

export interface UserListInterface extends UserInterface {
  fullName: string;
  createAt: Date;
  address: AddressInterface;
  accountSuspendedAt?: string;
}

export type User = UserInterface[] | null;

export function isAdmin(user: UserInterface | undefined | null): boolean {
  if (user && user.roles?.includes('Administrator')) {
    return true;
  }

  return false;
}

export function doesUserHaveAnyAllocationsToManage(user: UserInterface | null | undefined): boolean {
  if (!user) {
    return false;
  }

  return (user.canEditAllocations?.length ?? 0) > 0 ||
    (user.canSendTicketsFromAllocation?.length ?? 0) > 0 ||
    (user.readOnlyAllocations?.length ?? 0) > 0;
}

export function canUserEdit(user: UserInterface | null, allocationId: number): boolean {
  if (user && (isAdmin(user) || user.canEditAllocations?.includes(allocationId))) {
    return true;
  }

  return false;
}

export function canUserView(user: UserInterface | null, allocationId: number): boolean {
  if (user && (isAdmin(user) ||
    user.canEditAllocations?.includes(allocationId) ||
    user.readOnlyAllocations?.includes(allocationId) ||
    user.canSendTicketsFromAllocation?.includes(allocationId)
  )
  ) {
    return true;
  }

  return false;
}

export function canUserSendTicket(user: UserInterface | null, allocationId: number): boolean {
  if (user && (isAdmin(user) || user.canSendTicketsFromAllocation?.includes(allocationId))) {
    return true;
  }

  return false;
}

export function doesUserHaveAnyAllocation(user: UserInterface | null): boolean {
  if (!user) {
    return false;
  }

  if (isAdmin(user)) {
    return true;
  }

  return user.canEditAllocations?.length > 0 ||
    user.canSendTicketsFromAllocation?.length > 0 ||
    user.readOnlyAllocations?.length > 0;
}

export function isAllocationReadonlyForUser(user: UserInterface | null, allocationId: number): boolean {
  if (!user || (user && user.readOnlyAllocations.includes(allocationId))) {
    return true;
  }

  return false;
}

export function getUserBadgeText(user: UserInterface | null, allocationId: number): string {
  if (!user) {
    return "";
  }

  if (user.readOnlyAllocations?.includes(allocationId)) {
    return "Viewer";
  }

  if (user.canEditAllocations?.includes(allocationId)) {
    return "Send + Allocate";
  }

  if (user.canSendTicketsFromAllocation?.includes(allocationId)) {
    return "Sender";
  }

  return isAdmin(user) ? "Administrator" : "";
}